import moment from 'moment';
export class InventoryReceiptWrite {
    constructor(json) {
        this.quantity = json.quantity;
        this.inventorySubTypeId = json.inventory_sub_type_id;
    }
}
export class InventoryReceipt {
    constructor(json) {
        this.ownerOrgId = null;
        this.createdBy = null;
        this.id = json.id ?? null;
        this.quantity = json.quantity;
        this.inventorySubTypeId = json.inventory_sub_type_id;
        this.inventorySubTypeName = json.inventory_sub_type_name;
        this.ownerOrgId = json.owner_org_id;
        this.receiptType = json.receipt_type;
        this.createdBy = json.created_by ?? null;
        this.createdAt = moment.utc(json.created_at).local();
    }
}
//# sourceMappingURL=InventoryReceipt.js.map